export enum TechSector {
    WATER = 'water',
    HEATING = 'heating',
    WASTE_WATER = 'waste-water',
    FIRE_PROTECTION = 'fire-protection'
}